<template>
  <main class="gc-page">
    <section class="gc-hero" :style="{ backgroundImage: `url(${heroImage})` }">
      <div class="gc-hero-content">
        <h1>服务类别</h1>
        <p>真实技能。真实需求。真实邻居。</p>
        <p class="hero-desc">从宠物照料和技术帮助到活动策划和食品配送，<strong>19.9</strong> 将您的本地社区汇聚到一个简单、零佣金的市场中。无论您是提供服务还是寻找服务，只需不到一分钟即可发布、连接并开始。</p>
      </div>
    </section>

    <section class="gc-section light-blue">
      <div class="gc-container svc-categories">
        <h2 class="svc-title">
          <span class="svc-db">上传.</span>
          <span class="svc-lb">匹配.</span>
          <span class="svc-gr">收益.</span>
        </h2>
        <p class="svc-subtitle">探索我们的 17 个服务类别</p>
        <p class="svc-desc">每个类别都旨在让本地连接变得简单、直接、透明。</p>
        <div class="service-rows">
          <div v-for="(row, ri) in gridRows" :key="ri" class="service-row" :class="{ 'is-last': ri === gridRows.length - 1 }">
            <article v-for="item in row" :key="item.text" class="service-card">
              <div class="card-front">
                <img :src="item.url" alt="">
                <h3>{{ item.text }}</h3>
              </div>
              <div class="card-back">
                <p>{{ item.dir }}</p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="svc-hero-panel">
      <div class="svc-hero-overlay"></div>
      <div class="svc-hero-inner">
        <h2 class="svp-title" style="margin-bottom: 20%;">为日常奋斗者而生</h2>
        <div class="svp-icon-box">
          <div class="svp-icon-wrap">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="svp-svg svp-svg-def" width="48" height="48"><path d="M512.2 516.5c-68.6 0-133.1-26.7-181.5-75.2s-75.2-113-75.2-181.5 26.7-133.1 75.2-181.5S443.6 3 512.2 3s133.1 26.7 181.5 75.2c48.5 48.5 75.2 113 75.2 181.5s-26.7 133.1-75.2 181.5c-48.4 48.6-112.9 75.3-181.5 75.3z m0-433.5c-97.5 0-176.7 79.3-176.7 176.7 0 97.5 79.3 176.7 176.7 176.7S689 357.2 689 259.7C689 162.3 609.7 83 512.2 83zM881 1024c-22.1 0-40-17.9-40-40V777.4c0-82-62.1-149.8-141.8-158.8L543.9 807c-7.6 9.2-18.9 14.5-30.8 14.6h-0.1c-11.9 0-23.1-5.3-30.7-14.4L325.4 618.5c-79.7 8.9-141.9 76.8-141.9 158.8V984c0 22.1-17.9 40-40 40s-40-17.9-40-40V777.4c0-64.1 24.9-124.3 70.2-169.6 45.3-45.3 105.5-70.2 169.6-70.2 11.9 0 23.1 5.3 30.7 14.4l138.8 166.9 137.4-166.7c7.6-9.2 18.9-14.6 30.9-14.6 64.1 0 124.3 24.9 169.6 70.2S921 713.3 921 777.4V984c0 22.1-17.9 40-40 40z" fill="#1B5BA6"/><path d="M512 400.2c-77.3 0-140.1-62.9-140.1-140.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0 33.2 27 60.1 60.1 60.1 33.2 0 60.1-27 60.1-60.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0.1 77.2-62.8 140.1-140.1 140.1zM767 846H667c-22.1 0-40-17.9-40-40s17.9-40 40-40h100c22.1 0 40 17.9 40 40s-17.9 40-40 40z" fill="#1B5BA6"/></svg>
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="svp-svg svp-svg-hov" width="48" height="48"><path d="M512.2 516.5c-68.6 0-133.1-26.7-181.5-75.2s-75.2-113-75.2-181.5 26.7-133.1 75.2-181.5S443.6 3 512.2 3s133.1 26.7 181.5 75.2c48.5 48.5 75.2 113 75.2 181.5s-26.7 133.1-75.2 181.5c-48.4 48.6-112.9 75.3-181.5 75.3z m0-433.5c-97.5 0-176.7 79.3-176.7 176.7 0 97.5 79.3 176.7 176.7 176.7S689 357.2 689 259.7C689 162.3 609.7 83 512.2 83zM881 1024c-22.1 0-40-17.9-40-40V777.4c0-82-62.1-149.8-141.8-158.8L543.9 807c-7.6 9.2-18.9 14.5-30.8 14.6h-0.1c-11.9 0-23.1-5.3-30.7-14.4L325.4 618.5c-79.7 8.9-141.9 76.8-141.9 158.8V984c0 22.1-17.9 40-40 40s-40-17.9-40-40V777.4c0-64.1 24.9-124.3 70.2-169.6 45.3-45.3 105.5-70.2 169.6-70.2 11.9 0 23.1 5.3 30.7 14.4l138.8 166.9 137.4-166.7c7.6-9.2 18.9-14.6 30.9-14.6 64.1 0 124.3 24.9 169.6 70.2S921 713.3 921 777.4V984c0 22.1-17.9 40-40 40z" fill="#fff"/><path d="M512 400.2c-77.3 0-140.1-62.9-140.1-140.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0 33.2 27 60.1 60.1 60.1 33.2 0 60.1-27 60.1-60.1 0-22.1 17.9-40 40-40s40 17.9 40 40c0.1 77.2-62.8 140.1-140.1 140.1zM767 846H667c-22.1 0-40-17.9-40-40s17.9-40 40-40h100c22.1 0 40 17.9 40 40s-17.9 40-40 40z" fill="#fff"/></svg>
          </div>
          <p class="svp-desc">每个类别都遵循同样简单的方式：</p>
          <ol class="svp-steps">
            <li>发布您的需求——或者您能提供的服务</li>
            <li>本地连接</li>
            <li>保留 100% 的收入</li>
          </ol>
        </div>
        <p class="svp-bottom-text">
          <strong>没有佣金。没有算法。没有企业把关人。</strong>
        </p>
        <div class="svp-cta-wrap">
          <a class="svp-cta" href="#download">
            下载 APP
            <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18"/>
            </svg>
          </a>
        </div>
      </div>
    </section>

    <section class="gc-section svc-pricing">
      <div class="gc-container">
        <h2 class="svc-pricing-title">简单。透明。公平。</h2>
        <p class="svc-pricing-sub">我们的模式简单明了。</p>

        <div class="svc-pricing-card">
          <div class="svc-pricing-card-inner">
            <p class="svc-pricing-label" style="font-size: 2rem;">每月每个类别</p>
            <p class="svc-pricing-price" style="margin: 20% 0 50% 0;">￥19.90</p>
            <a class="svc-pricing-cta" href="#download">
              立即开始！
              <svg class="phone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18"/>
              </svg>
            </a>
          </div>
        </div>

        <h3 class="svc-pricing-thatsit">仅此而已！</h3>
        <p class="svc-pricing-desc">
          没有佣金比例。没有意外的扣款。没有隐藏在细文中的费用。<br>
          一分钟内发布或请求一项服务。根据您的需求本地匹配。<br>
          自由畅聊。保持掌控。
        </p>
      </div>
    </section>

    <section class="svc-community">
      <div class="svc-community-overlay"></div>
      <div class="svc-community-inner">
        <h2 class="svc-community-title">为真实连接<span>而设计的市场</span></h2>
        <div class="svc-community-text">
          <p><strong>19.9</strong> 不是为了扩大企业机器。而是为了加强本地社区。</p>
          <p>当邻居直接连接，价值留在本地。</p>
          <p>当服务者保留全部收入，机会就会扩大。</p>
          <p>当平台不再干预，信任就会增长。</p>
          <p><strong>这是一个重新连接的社区。</strong></p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'ServicesView',
  data() {
    return {
      heroImage: 'https://goodconnex.com/wp-content/uploads/2026/03/Service-Banner_Finalsmall.webp',
      itemlist: [
        { text: '美食', dir: '提供家常餐、特色菜、餐饮承办服务，或连接您附近的本地餐食提供者。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%8B%BF%E6%89%8B%E8%8F%9C.png' },
        { text: '出行', dir: '提供交通服务，或在需要搭车时找到值得信赖的本地司机。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%89%93%E8%BD%A6.png' },
        { text: '配送', dir: '从杂货到小包裹，连接可以快速可靠帮您搬运物品的邻居。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E9%85%8D%E9%80%81.png' },
        { text: '房屋租赁', dir: '发布可出租房源，或在社区中寻找长期、短期等灵活租赁选择。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%88%BF%E5%B1%8B.png' },
        { text: '房地产', dir: '覆盖住宅、商业地产和专项投资，为各类地产需求提供本地连接。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%88%BF%E5%B1%8B.png' },
        { text: '汽车', dir: '无论是新车、二手车还是汽车租赁，都可以在这里发布或寻找。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%B1%BD%E8%BD%A6.png' },
        { text: '酒店', dir: '发布客房、短住服务，或直接寻找本地住宿选择，不受平台干预。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E9%85%92%E5%BA%97.png' },
        { text: '工作', dir: '发布工作机会，或向本地区雇主展示您的技能。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E6%B1%82%E8%81%8C.png' },
        { text: '搬家', dir: '寻找装卸、运输或整理搬家的帮助。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/banjia1.png' },
        { text: '美容', dir: '美发、化妆、个人造型、护理等本地服务，按您的方式提供。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/meirongmeifa1.png' },
        { text: '宠物', dir: '遛狗、宠物看护、美容、训练，在邻里间找到可信赖的照护。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/chongwu1.png' },
        { text: '教练', dir: '健身教练、人生教练、运动指导、表现导师，提供或寻找指导。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E5%9F%B9%E8%AE%AD.png' },
        { text: '家教', dir: '学业辅导、音乐课程、语言教学、考试准备，直接建立联系。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E5%9F%B9%E8%AE%AD.png' },
        { text: '照护', dir: '儿童照护、老人照护、陪伴和生活协助，提供本地可信支持。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/peiban1.png' },
        { text: '专业服务', dir: '法律、会计、咨询、营销、设计、技术支持等独立专业服务。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/zhuanyefuwu1.png' },
        { text: '家政家居', dir: '房屋维修、清洁、整理、庭院维护、杂工服务，寻找帮助或提供专长。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E5%AE%B6%E6%94%BF.png' },
        { text: '其他', dir: '有不属于现有分类的技能？直接发布。19.9 为灵活服务而生。', url: 'https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/ionc1/%E5%85%B6%E4%BB%96.png' }
      ]
    }
  },
  computed: {
    gridRows() {
      const list = this.itemlist
      const perRow = 4
      const rows = []
      for (let i = 0; i < list.length; i += perRow) {
        rows.push(list.slice(i, i + perRow))
      }
      // 最后一行的卡片数小于4且总行数大于1，合并到倒数第二行
      if (rows.length > 1 && rows[rows.length - 1].length < perRow) {
        const last = rows.pop()
        rows[rows.length - 1] = rows[rows.length - 1].concat(last)
      }
      return rows
    }
  }
}
</script>

<style scoped>
.hero-desc {
  max-width: 820px;
  margin: 28px auto 0;
  font-size: 18px;
  line-height: 1.7;
  font-weight: 500;
  text-shadow: 1px 2px 0 rgba(0, 0, 0, 0.2);
}

.hero-desc strong {
  font-weight: 800;
}

/* Post. Connect. Earn. */
.svc-categories {
  text-align: center;
}

.svc-title {
  font-size: clamp(48px, 7vw, 80px);
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 20px;
}

.svc-db {
  color: #1B3A5C;
}

.svc-lb {
  color: #5BA4CF;
}

.svc-gr {
  color: #4CAF50;
}

.svc-subtitle {
  font-size: clamp(22px, 3vw, 32px);
  font-weight: 800;
  color: #1f2933;
  margin-bottom: 14px;
}

.svc-desc {
  font-size: 18px;
  color: #68717b;
  margin-bottom: 52px;
}

/* Card flip */
.service-rows {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.service-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

.service-row.is-last {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.service-row.is-last .service-card {
  flex: 0 0 calc(20% - 18px);
  max-width: calc(20% - 18px);
}

.service-card {
  height: 275px;
  border-radius: 6px;
  text-align: center;
  position: relative;
}

.service-card:hover {
  z-index: 2;
}

.card-front,
.card-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transition: transform 0.5s ease;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(20, 66, 86, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 26px 20px;
  box-sizing: border-box;
}

.card-front {
  position: relative;
}

.card-back {
  transform: rotateY(180deg);
  background: #1765b2;
  color: #fff;
}

.card-back p {
  color: #fff;
  font-size: 15px;
  line-height: 1.6;
  font-weight: 600;
}

.service-card:hover .card-front {
  transform: rotateY(180deg);
}

.service-card:hover .card-back {
  transform: rotateY(0deg);
}

.service-card img {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 18px;
}

.service-card h3 {
  font-size: 24px;
  color: #15242d;
  font-weight: 900;
  margin-bottom: 0;
}

@media (max-width: 980px) {
  .service-card {
    height: 240px;
  }
}

/* Hero image panel */
.svc-hero-panel {
  position: relative;
  min-height: 650px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 28px;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/About-Us-Block2.jpg") center/cover;
}

.svc-hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(27, 91, 166, 0.55);
  z-index: 1;
}

.svc-hero-inner {
  position: relative;
  z-index: 2;
  max-width: 820px;
  text-align: center;
}

.svp-title {
  font-size: clamp(48px, 7vw, 80px);
  font-weight: 900;
  color: #fff;
  line-height: 1.05;
  margin-bottom: 4px;
}

.svp-subtitle {
  font-size: clamp(48px, 7vw, 80px);
  font-weight: 900;
  color: #F5EBD0;
  line-height: 1.05;
  text-decoration: underline;
  text-underline-offset: 12px;
  text-decoration-thickness: 4px;
  margin-bottom: 42px;
}

.svp-icon-box {
  background: rgba(245, 235, 208, 0.35);
  border-radius: 20px;
  padding: 48px 44px;
  max-width: 780px;
  margin: 0 auto 42px;
}

.svp-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  margin-bottom: 24px;
}

.svp-svg {
  position: absolute;
}

.svp-svg-def {
  display: block;
}

.svp-svg-hov {
  display: none;
}

.svp-icon-wrap:hover {
}

.svp-icon-wrap:hover .svp-svg-def {
  display: none;
}

.svp-icon-wrap:hover .svp-svg-hov {
  display: block;
}

.svp-desc {
  color: #000;
  font-size: 20px;
  line-height: 1.6;
  font-weight: 700;
  text-align: center;
  margin-bottom: 22px;
}

.svp-steps {
  text-align: left;
  display: inline-block;
  margin: 0 auto;
  padding-left: 24px;
  color: #000;
  font-size: 18px;
  line-height: 2;
  font-weight: 600;
}

.svp-bottom-text {
  color: #fff;
  font-size: 22px;
  line-height: 1.6;
  max-width: 760px;
  margin: 0 auto 36px;
  text-align: center;
  width: 100%;
}

.svp-bottom-text strong {
  font-weight: 800;
}

.svp-cta-wrap {
  text-align: center;
}

.svp-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 56px;
  padding: 0 36px;
  border-radius: 10px;
  background: #1B5BA6;
  color: #fff;
  text-decoration: none;
  font-weight: 800;
  font-size: 18px;
  transition: background 0.2s;
  box-shadow: 0 4px 16px rgba(27, 91, 166, 0.4);
}

.svp-cta:hover {
  background: #174a8a;
}

.svp-cta .phone-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Pricing section */
.svc-pricing {
  background: #fff;
  text-align: center;
}

.svc-pricing-title {
  font-size: clamp(42px, 6vw, 68px);
  font-weight: 900;
  color: #1f2933;
  margin-bottom: 18px;
  line-height: 1.05;
}

.svc-pricing-sub {
  font-size: 20px;
  color: #68717b;
  margin-bottom: 52px;
}

.svc-pricing-card {
  max-width: 520px;
  margin: 0 auto 52px;
  border-radius: 16px;
  overflow: hidden;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/LOGO-Banner_Final.jpg") center/cover;
  position: relative;
}

.svc-pricing-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(245, 235, 208, 0.78);
  z-index: 1;
}

.svc-pricing-card-inner {
  position: relative;
  z-index: 2;
  padding: 56px 36px;
}

.svc-pricing-label {
  color: #1765b2;
  font-size: 18px;
  font-weight: 900;
  margin-bottom: 14px;
}

.svc-pricing-price {
  color: #A75F26;
  font-size: clamp(60px, 9vw, 96px);
  font-weight: 900;
  line-height: 1;
  margin-bottom: 32px;
}

.svc-pricing-thatsit {
  color: #1765b2;
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 900;
  margin-bottom: 24px;
}

.svc-pricing-desc {
  max-width: 720px;
  margin: 0 auto;
  font-size: 19px;
  line-height: 1.8;
  color: #68717b;
}

.svc-pricing-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 56px;
  padding: 0 36px;
  border-radius: 10px;
  background: #1B5BA6;
  color: #fff;
  text-decoration: none;
  font-weight: 800;
  font-size: 18px;
  transition: background 0.2s;
  box-shadow: 0 4px 16px rgba(27, 91, 166, 0.4);
}

.svc-pricing-cta:hover {
  background: #174a8a;
}

.svc-pricing-cta .phone-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Community panel */
.svc-community {
  position: relative;
  min-height: 650px;
  display: flex;
  align-items: center;
  padding: 100px 28px;
  background: url("https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/About-Us-Block3b.webp") center/cover;
}

.svc-community-overlay {
  position: absolute;
  inset: 0;
  background: rgba(27, 91, 166, 0.55);
  z-index: 1;
}

.svc-community-inner {
  position: relative;
  z-index: 2;
  width: min(1120px, 100%);
  margin: 0 auto;
}

.svc-community-title {
  font-size: clamp(40px, 5.5vw, 64px);
  font-weight: 900;
  color: #fff;
  line-height: 1.1;
  margin-bottom: 48px;
}

.svc-community-title span {
  color: #F5EBD0;
}

.svc-community-text {
  text-align: left;
  max-width: 720px;
}

.svc-community-text p {
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
  margin-bottom: 12px;
}

.svc-community-text p strong {
  font-weight: 800;
}

@media (max-width: 980px) {
  .hero-desc {
    font-size: 15px;
    line-height: 1.6;
  }

  .service-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .service-row.is-last .service-card {
    flex: 0 0 calc(50% - 11px);
    max-width: calc(50% - 11px);
  }

  .svc-hero-panel {
    min-height: 480px;
    padding: 72px 24px;
  }

  .svp-icon-box {
    padding: 32px 22px;
  }

  .svp-desc {
    font-size: 15px;
  }

  .svp-bottom-text {
    font-size: 16px;
  }

  .svc-pricing-card-inner {
    padding: 40px 24px;
  }

  .svc-pricing-desc {
    font-size: 16px;
  }

  .svc-community {
    min-height: 480px;
    padding: 72px 24px;
  }

  .svc-community-title {
    font-size: clamp(30px, 7vw, 44px);
    margin-bottom: 32px;
  }

  .svc-community-text p {
    font-size: 16px;
    line-height: 1.7;
  }
}

@media (max-width: 560px) {
  .service-row {
    grid-template-columns: 1fr;
  }

  .service-row.is-last .service-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
